import ActionTypeMapping from './ActionTypeMapping';

class ActionTypeMappingsStore {
  constructor(data) {
    this.loading = !data || data.loading;
    this.store = ((data && (data.store || data)) || []).map(d => new ActionTypeMapping(d));
  }

  isEmpty() {
    return this.store.length === 0;
  }

  find(id) {
    return this.store.find(mapping => mapping.id === id) || false;
  }

  dup() {
    return new ActionTypeMappingsStore(this.store);
  }

  map(fn) {
    return this.store.map(fn);
  }

  updateActionTypeMapping(updatedData) {
    const mapping = this.find(updatedData.id);
    if (mapping) Object.assign(mapping, updatedData);
  }

  sorted() {
    return this.store.sort((a, b) => (a.createdAt > b.createdAt ? -1 : 1));
  }
}

export default ActionTypeMappingsStore;
